<template>
    <div class="QHiconselect">
        <div class="ivu-color-picker" @click="show=true">
            <div class="ivu-color-picker-rel ivu-color-picker-default ivu-input-wrapper ivu-input-wrapper-default">
                <input type="hidden" value="rgba(74,104,136,1)"> <i
                    class="ivu-icon ivu-icon-ios-arrow-down ivu-input-icon ivu-input-icon-normal"></i>
                <div tabindex="0" class="ivu-color-picker-input ivu-input ivu-input-default">
                    <div class="ivu-color-picker-color">
                        <div class="flex-center" style="background-color:#fff;line-height:18px;border:none;box-shadow:none;" :class="values" v-if="values"></div>
                    </div>
                </div>
            </div>
        </div>
        <Modal  :mask-closable="false" v-model="show" :width="1000" title="图标选择"
            :footer-hide="true">
            <ul class="iconList">
                <li @click="getValue('')">无</li>
                <li v-for="(item, index) in iconList" :key="index" @click="getValue(item)">
                    <Icon :custom="item" />
                </li>
            </ul>
        </Modal>
    </div>
</template>

<script>
import data from "@/configOs/iconfont/iconfont.js";
export default {
    data() {
        return {
            values:"",
            show: false,
            iconList: data.icon,
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        value: {
            type: String,
            default: ""
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:watch
    // +----------------------------------------------------------------------
    watch: {
        value() {
            this.setValue();
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        getValue(data) {
            this.$emit('input', data);
            this.show = false;
            this.values="";
        },
        setValue() {
            if (!this.$isblank(this.value)) {
                this.values = this.value;
            };
        },
    }
}
</script>
<style>
.QHiconselect{cursor: pointer;}
.ivu-color-picker{cursor: pointer;}
.iconList {
    overflow: hidden;
}

.iconList li {
    display: inline-block;
    width: 35px;
    height: 35px;
    margin: 5px;
    border: 1px solid #f1f1f1;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    cursor:pointer;
}

.iconList li i {
    color: #999;
    font-size: 20px;
    cursor: pointer;
}

.iconList li:hover {
    border-color: #3975C6;
}

.iconList li:hover i {
    color: #3975C6;
}
</style>
